


















































import { Component, Vue } from 'vue-property-decorator';
import { State, Action, namespace } from 'vuex-class';

const isFeatureEnabled = async function (to: any, context: Vue): Promise<boolean> {
	const store = context.$store;
	if (!store.state.settings.clientSettings) {
		try {
			await store.dispatch('settings/fetchClientSettings');
		}
		catch (e) {
			return false;
		}
	}

	if (to.meta.enabled != null && store.state.settings.clientSettings && !to.meta.enabled(store.state.settings.clientSettings)) {
		return false;
	}

	return true;
};

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteLeave',
	'beforeRouteUpdate'
]);

/**
 * Types
 */
import { SettingsResponseModel } from './api/settings';

/**
 * VueX Modules
 */
const clientSettingsModule = namespace('settings');

@Component({
	watch: {
		windowTitle: function (val) {
			document.title = val;
		}
	}
})
export default class App extends Vue {
	/** VueX - Settings */
	@clientSettingsModule.Getter
	settings!: SettingsResponseModel;

	@clientSettingsModule.Action
	fetchClientSettings!: () => Promise<SettingsResponseModel>;

	/** Attributs */
	windowTitle = "";
	title = "";
	isLoading = false;

	/** Méthodes */
	async created() {
		this.isLoading = true;
		await this.fetchClientSettings();
		if (this.settings != null) {
			this.windowTitle = this.settings.general.applicationTitle;
		}
		this.isLoading = false;
	}

	async beforeRouteEnter(to: any, from: any, next: any) {
		next(async (vm: any) => {
			const gR = await isFeatureEnabled(to, vm);
			if (!gR) {
				return vm.$router.push('/');
			}
			vm.title = to.meta.title;
		});
	}
	async beforeRouteUpdate(to: any, from: any, next: any) {
		const gR = await isFeatureEnabled(to, this);
		if (!gR) {
			return this.$router.push('/');
		}

		this.title = to.meta.title;
		next();
	}
}
